import type { FulfillmentMethod } from '../lib';
import './set-up-autoship.scss';

const IMMEDIATE_TITLES: Record<FulfillmentMethod, string> = {
    bopis: 'Pick up today',
    sdd: 'Delivered today',
    sth: 'Delivered in 1-3 days',
};

type SetUpAutoshipImmediateTitleProps = Readonly<{
    fulfillmentMethod: FulfillmentMethod;
    storeName?: string;
}>;

export const SetUpAutoshipImmediateTitle = ({ fulfillmentMethod, storeName }: SetUpAutoshipImmediateTitleProps) => {
    const title = IMMEDIATE_TITLES[fulfillmentMethod];

    if (fulfillmentMethod === 'bopis' && storeName) {
        return (
            <span>
                {title} <span className="set-up-autoship__store-name">at {storeName}</span>
            </span>
        );
    }

    return title;
};
